<script setup lang="ts">
import { mdiChevronDown } from '@mdi/js'
import type { Validate } from '@/shared/types/validation.types'

import SvgIcon from '@/shared/components/icon/SvgIcon.vue'

interface Props {
  active?: boolean
  disabled?: boolean
  validation?: Validate
}

defineProps<Props>()
</script>

<template>
  <SvgIcon
    :path="mdiChevronDown"
    class="transition linear duration-200 w-5 h-5"
    :class="[
      active ? 'rotate-180' : 'rotate-0',
      disabled
        ? 'fill-gray-400'
        : validation?.isDirty && validation?.isInvalid
          ? 'fill-error'
          : 'fill-gray-700 dark:fill-gray-300',
    ]"
    v-bind="$attrs"
  />
</template>
